const hostname = window.location.hostname;
const getBaseUrl = () => {
  if (hostname === "localhost" || hostname === "react.webykw.com") {
    return "https://uat.webykw.com/api"; // Local API
  } else {
    return `${hostname}/api`; // Staging API
  }
};

export const BASE_URL = getBaseUrl();
export const ENVIRONMENT =
  hostname === "localhost" ? "development" : "production";

export function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

// export const getDeviceType = () => {
//   const ua = navigator.userAgent;
//   if (/android/i.test(ua)) return "Android";
//   if (/iPad|iPhone|iPod/.test(ua)) return "iOS";
//   if (/Windows/.test(ua)) return "Windows";
//   if (/Macintosh/.test(ua)) return "Mac";
//   if (/Linux/.test(ua)) return "Linux";
//   return "Unknown";
// };
